module.exports = __webpack_public_path__ + "static/ana_l.afba811d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/ana_l.png
// module id = 1712
// module chunks = 35783957827783